import React from 'react';
import PropTypes from 'prop-types';

const ProgressBar = ({ percentage, count }) => {
  return (
    <div className='progress'>
      <div
        className='progress-bar progress-bar-striped progress-bar-animated bg-success'
        role='progressbar'
        style={{ width: `${percentage}%` }}
      >
        {percentage}% ({count})
      </div>
    </div>
  );
};

ProgressBar.propTypes = {
  percentage: PropTypes.number.isRequired
};

export default ProgressBar;
